module.exports = __webpack_public_path__ + "static/IMG_0059-f5eeb3f723bbb574d2693791cc49203f.jpg";